<xemex-authorization-container [isLoading]="store.isLoading()">
  <div class="flex flex-col items-center gap-4 text-center">
    <div
      class="flex items-center justify-center w-16 h-16 rounded-full bg-status-success text-primary"
    >
      <mat-icon>{{ hasJoined() ? 'check_circle' : 'groups' }}</mat-icon>
    </div>

    <h1 class="text-2xl font-bold">
      {{ (hasJoined() ? 'joinNetwork.success.title' : 'joinNetwork.title') | translate }}
    </h1>

    @if (!hasJoined()) {
      <p class="text-sm text-neutral">
        {{ 'joinNetwork.desc' | translate: { companyName: partnerName } }}
      </p>
    }

    @if (store.authFeedback(); as feedback) {
      <xemex-alert-banner class="w-full" [variant]="feedback.variant">
        {{ feedback.key | translate: { companyName: partnerName } }}
      </xemex-alert-banner>
    }

    @if (hasJoined()) {
      <xemex-filled-button class="w-full" [fullWidth]="true" (click)="backToLogin()">
        {{ 'general.btnBackToLogin' | translate }}
      </xemex-filled-button>
    } @else {
      <xemex-filled-button
        class="w-full"
        [fullWidth]="true"
        [loading]="store.isLoading()"
        (click)="onJoinNow()"
      >
        {{ 'joinNetwork.btnJoin' | translate }}
      </xemex-filled-button>
    }
  </div>
</xemex-authorization-container>
